// ABOUTME: The error boundary of the public /interview route, which has no react-router errorElement: a render crash is
// ABOUTME: reported and offers a reload, which redeems the link still in the URL again.
import { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { logError } from 'utils/datadog';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/** Copy is hardcoded on purpose, as in GuestFormErrorBoundary: what crashed may be a provider the copy needs. */
export class GuestInterviewErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    logError('Guest interview render crash', error, {
      feature: 'interviews',
      componentStack: info.componentStack ?? undefined
    });
  }

  private handleReload = (): void => {
    window.location.reload();
  };

  render(): ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: 2,
          px: 3
        }}
      >
        <Typography variant="h4">Etwas ist schiefgelaufen</Typography>
        <Typography variant="body2" color="text.secondary">
          Bitte lade die Seite neu, um fortzufahren.
        </Typography>
        <Button variant="contained" onClick={this.handleReload}>
          Seite neu laden
        </Button>
      </Box>
    );
  }
}
